import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function J() {
    const { t } = useLang('bkw');
    return (
        <div id="bkw-J" className={`bkw-J bkw-box ${css['bkw-J']}`}>
            <EfSpec />
            <div className="img-box">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1738898708394/9.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1738898734710/9_M.jpg"
                />
                <div className="info">
                    <h2 className="title">
                        {t.rich('J_title', {
                            y: (tx: string) => <span className="y">{tx}</span>,
                        })}
                    </h2>
                    <p className="desc">{t('J_desc')}</p>
                </div>
            </div>
        </div>
    );
}
